export const getters = {
  ecrans (state) {
    return state.ecrans
  },
  ecran (state) {
    return state.ecran
  },  
  pagination(state){
    return state.pagination
  }
}
